import React, { forwardRef } from 'react';
import styles from './IconButton.module.scss';
import Icon from 'utils/components/icon';
import classNames from 'classnames';
import { SettingsIcon } from 'app/scripts/icons';

interface ButtonProps {
  icon?: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

type IconButtonProps = Omit<ButtonProps, 'icon'>;

const IconButton = forwardRef<HTMLButtonElement, ButtonProps>(function IconButton(props, ref) {
  const { icon, onClick, className, disabled, children } = props;

  return (
    <button
      className={classNames(styles.iconButton, className)}
      onClick={onClick}
      disabled={disabled}
      ref={ref}
    >
      {icon ? <Icon name={icon} /> : children}
    </button>
  );
});

const SettingsButton = (props: IconButtonProps): JSX.Element => {
  return (
    <IconButton {...props}>
      <SettingsIcon />
    </IconButton>
  );
};

const AddButton = (props: IconButtonProps): JSX.Element => {
  return <IconButton icon="add" {...props} />;
};

const RemoveButton = forwardRef<HTMLButtonElement, IconButtonProps>(function RemoveButton(
  props,
  ref
): JSX.Element {
  return <IconButton icon="remove" ref={ref} {...props} />;
});

const EditButton = (props: IconButtonProps): JSX.Element => {
  return <IconButton icon="edit" {...props} />;
};

export { SettingsButton, AddButton, RemoveButton, EditButton };
